import React from 'react'

import { InternationalizationNotSupportedError } from '@nw/omega-design-system'

import {
  FailureImage,
  FailureViewContainer,
  FailureViewMessage
} from './styledComponents'

interface ErrorBoundaryProps {
  error: Error
  componentStack: string | null
  eventId: string | null
  resetError(): void
}

export const ErrorBoundaryFallback = (props: ErrorBoundaryProps) => {
  const { error } = props

  const InternalizationError = props => {
    return (
      <FailureViewContainer>
        <FailureImage
          className="failure-view-image"
          src="https://d15dkfioxfhy94.cloudfront.net/tenxiitian_prod/website-static/connection-lost.png"
        />
        <FailureViewMessage>
          {'Please update your browser to the latest version'}
        </FailureViewMessage>
      </FailureViewContainer>
    )
  }

  const DefaultError = props => {
    const { errorMessage } = props

    return (
      <FailureViewContainer>
        <FailureImage
          className="failure-view-image"
          src="https://d15dkfioxfhy94.cloudfront.net/tenxiitian_prod/website-static/connection-lost.png"
        />
        <FailureViewMessage>
          {errorMessage ? errorMessage : 'Oops! Something went wrong'}
        </FailureViewMessage>
      </FailureViewContainer>
    )
  }

  const renderComponent = () => {
    switch (true) {
      case error instanceof InternationalizationNotSupportedError:
        return <InternalizationError errorMessage={error.message} />
      default:
        return <DefaultError errorMessage={error.message} />
    }
  }

  return <>{renderComponent()}</>
}
